import { useParams } from 'react-router-dom'
import MTable from '../../components/mtable'
import Title from '../../components/Title'
import { useState } from 'react'
import Loading from '../../components/loading'
import { api } from '../../env'
import { ConfirmButton } from '../../components/ConfirmButton'
import { MatchingState } from '../../utils/enums'

export default function MatchingOverride() {
    
    const { id } = useParams()

    const [inProgress, setInProgress] = useState(false)

    const mapper = {columns: [
        {
            label: 'Mentor',
            value: (item) => `${item.mentorEnrollment.user.firstName} ${item.mentorEnrollment.user.lastName}`
        },
        {
            label: 'Mentee',
            value: (item) => `${item.menteeEnrollment.user.firstName} ${item.menteeEnrollment.user.lastName}`
        },
        {
            label: '',
            width: '180px',
            actions: [
                {
                    label: 'Reject',
                    style: (_) => 'solid-accent',
                    onClick: (item) => rejectOne(item.id)
                },
                {
                    label: 'Approve',
                    style: (_) => 'solid',
                    onClick: (item) => approveOne(item.id)
                }
            ]
        } 
    ]}

    const approveOne = (id) => {
        setInProgress(true)
        api.post(`matches/${id}/approve`)
            .then(_ => setInProgress(false))
            .catch(_ => setInProgress(false))
    }

    const rejectOne = (id) => {
        setInProgress(true)
        api.post(`matches/${id}/reject-preview`)
            .then(_ => setInProgress(false))
            .catch(_ => setInProgress(false))
    }

    const approveAll = () => {
        if (!id || inProgress) return
        setInProgress(true)
        api.post(`programs/${id}/matches/approve-all`)
            .then(_ => setInProgress(false))
            .catch(_ => setInProgress(false))
    }

    const rejectAll = () => {
        if (!id || inProgress) return
        setInProgress(true)
        api.post(`programs/${id}/matches/reject-all-preview`)
            .then(_ => setInProgress(false))
            .catch(_ => setInProgress(false))
    }

    return(<div className='standard-padding page-xl-centered showing'>
        <div className='flex space-between gap-xs wrap v-spacer-m'>
            <Title>Review Matches</Title>
            {id && <div className='flex center gap-xs'>
                <ConfirmButton label={'Approve All'} onClick={approveAll}/>
                <ConfirmButton label={'Reject All'} onClick={rejectAll}/>
            </div>}
        </div>
        {id && !inProgress && <MTable path={`programs/${id}/matches`} queryParams={{matchStatus: MatchingState.PREVIEW}} mapper={mapper} itemsPerPage={20}/>}
        {inProgress && <Loading label={"Applying Response ..."}/>}
    </div>)
}